import Panorama from '@/components/Panorama'
import PanoramaBuildSpot from '@/components/spots/PanoramaBuildSpot'
import PanoramaControl from '@/components/PanoramaControl'
import PanoramaImageSource from '@/components/elements/PanoramaImageSource'
import PanoramaModal from '@/components/elements/PanoramaModal'
import PanoramaSpot from '@/components/elements/PanoramaSpot'
import PanoramaSpotIcon from '@/components/elements/PanoramaSpotIcon'
import PanoramaUIAccordion from '@/components/ui/PanoramaUIAccordion'
import PanoramaUiPoint from '@/components/spots/PanoramaPointSpot'
import PanoramaUiSelect from '@/components/ui/PanoramaUiSelect'
import PanoramaAccordionIcon from '@/components/icons/PanoramaAccordionIcon'
import PanoramaCallHintIcon from '@/components/icons/PanoramaCallHintIcon'
import PanoramaCloseIcon from '@/components/icons/PanoramaCloseIcon'
import PanoramaSliderPoint from '@/components/icons/PanoramaSliderPoint'
import structure from '@/structure'
import PanoramaIconBuilding from '@/components/icons/spot/PanoramaIconBuilding'
import PanoramaIconTower from '@/components/icons/spot/PanoramaIconTower'
import PanoramaIconShop from '@/components/icons/spot/PanoramaIconShop'
import PanoramaLogoZk from '@/components/icons/spot/PanoramaLogoZk'
import PanoramaStoreModule from '@/store/Panorama'
import PanoramaIconTree from '@/components/icons/spot/PanoramaIconTree'
import PanoramaIconCar from '@/components/icons/spot/PanoramaIconCar'
import PanoramaIconForest from '@/components/icons/spot/PanoramaIconForest'
import PanoramaIconFirTree from '@/components/icons/spot/PanoramaIconFirTree'
import PanoramaIconFitness from '@/components/icons/spot/PanoramaIconFitness'
import PanoramaIconHealth from '@/components/icons/spot/PanoramaIconHealth'
import PanoramaIconElectric from '@/components/icons/spot/PanoramaIconElectric'
import PanoramaIconMetro from '@/components/icons/spot/PanoramaIconMetro'
import PanoramaIconRoad from '@/components/icons/spot/PanoramaIconRoad'
import PanoramaIconBook from '@/components/icons/spot/PanoramaIconBook'
import PanoramaIconKindergarten from '@/components/icons/spot/PanoramaIconKindergarten'
import PanoramaIconFootboall from '@/components/icons/spot/PanoramaIconFootboall'
import PanoramaIconKid from '@/components/icons/spot/PanoramaIconKid'
import PanoramaIconYoga from '@/components/icons/spot/PanoramaIconYoga'
import PanoramaIconMosque from '@/components/icons/spot/PanoramaIconMosque'
import PanoramaIconTRC from '@/components/icons/spot/PanoramaIconTRC'
import PanoramaIconCaseCross from '@/components/icons/spot/PanoramaIconCaseCross'
import PanoramaIconBank from '@/components/icons/spot/PanoramaIconBank'
import PanoramaIconTrailer from '@/components/icons/spot/PanoramaIconTrailer'
import PanoramaIconMusic from '@/components/icons/spot/PanoramaIconMusic'
import PanoramaIconSwim from '@/components/icons/spot/PanoramaIconSwim'
import PanoramaIconCamera from '@/components/icons/spot/PanoramaIconCamera'
import PanoramaIconGirl from '@/components/icons/spot/PanoramaIconGirl'
import PanoramaIconFood from '@/components/icons/spot/PanoramaIconFood'
import PanoramaIconMuseum from '@/components/icons/spot/PanoramaIconMuseum'
import PanoramaIconBoat from '@/components/icons/spot/PanoramaIconBoat'
import PanoramaIconElephant from '@/components/icons/spot/PanoramaIconElephant'
import PanoramaIconPaw from '@/components/icons/spot/PanoramaIconPaw'
import PanoramaIconRiver from '@/components/icons/spot/PanoramaIconRiver'
import PanoramaIconOffice from '@/components/icons/spot/PanoramaIconOffice'
import PanoramaIconOfficeOne from '@/components/icons/spot/PanoramaIconOfficeOne'
import PanoramIconMetroVodnii from '@/components/icons/spot/PanoramIconMetroVodnii'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VuePano from '@black40x/vue-pano'
/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep (target, ...sources) {
  const isObject = item => item && typeof item === 'object' && !Array.isArray(item)
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key]) && key.toString()[0] !== '_') {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

const defaultOptions = {
  structure: structure,
  utils: {
    /**
     * Функция эмуляции вызова события на DOM элементе
     * @param el
     * @param etype
     */
    eventFire (el, etype) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype)
      } else {
        const evObj = document.createEvent('Events')
        evObj.initEvent(etype, true, false)
        el.dispatchEvent(evObj)
      }
    },
    urLSearchParams: new URLSearchParams(window.location.href.split('?')[1]),
    isMobile: window.innerWidth < 768,
    delay: (ms) => {
      return new Promise(resolve => {
        setTimeout(resolve, ms)
      })
    }
  },
  options: {
    fov: {
      min: 30,
      start: 50,
      max: 65,
      _minMobile: 45,
      _maxMobile: 65
    }
  },
  data: {
    minAmount: {
      1: 9556700,
      2: 12694500,
      3: 14448000,
      4: 24182700,
      'Евро-4': 17850400,
      'Евро-3': 14537900,
      'Евро-2': 10912500,
      'Евро-5': 32338000,
      Студия: 8149000
    }
  },
  control: {
    categories: [
      'окружение',
      'Удобство',
      'Гармония',
      'Развитие',
      'Семья'
    ]
  },
  styles: {
    vars: {
      'background-color': '#E5D1CA',
      'text-color': '#303147',
      'subtitle-color': '#a2a4a5',
      'secondary-color': '#8E96A3',
      'first-font': 'Bebas Neue, sans-serif',
      'second-font': 'Rubik, sans-serif'
    },
    colors: {
      backlightLayoutColor: 0x4787EE
    }
  },
  spot: {
    icons: {
      building: PanoramaIconBuilding,
      tower: PanoramaIconTower,
      shop: PanoramaIconShop,
      logo: PanoramaLogoZk,
      tree: PanoramaIconTree,
      car: PanoramaIconCar,
      forest: PanoramaIconForest,
      office: PanoramaIconOffice,
      officeOne: PanoramaIconOfficeOne,
      metroVodnii: PanoramIconMetroVodnii,
      firTree: PanoramaIconFirTree,
      fitness: PanoramaIconFitness,
      health: PanoramaIconHealth,
      electric: PanoramaIconElectric,
      metro: PanoramaIconMetro,
      road: PanoramaIconRoad,
      book: PanoramaIconBook,
      kinder: PanoramaIconKindergarten,
      football: PanoramaIconFootboall,
      kid: PanoramaIconKid,
      yoga: PanoramaIconYoga,
      mosque: PanoramaIconMosque,
      TRC: PanoramaIconTRC,
      caseCross: PanoramaIconCaseCross,
      bank: PanoramaIconBank,
      trailer: PanoramaIconTrailer,
      music: PanoramaIconMusic,
      swim: PanoramaIconSwim,
      camera: PanoramaIconCamera,
      girl: PanoramaIconGirl,
      food: PanoramaIconFood,
      museum: PanoramaIconMuseum,
      boat: PanoramaIconBoat,
      elephant: PanoramaIconElephant,
      paw: PanoramaIconPaw,
      river: PanoramaIconRiver
    }
  },
  handlers: {
    clickShowMoreInfoApartments (quantity) {
      let origin = ''
      if (document.referrer) {
        const url = document.referrer
        origin = url.split('/').slice(0, 3).join('/')
      }
      if (origin !== '') {
        window.parent.location.href = origin + '/apartments?quantity=' + quantity
      }
    }
  }
}

const Components = [
  Panorama
]

const install = (Vue, options = {}) => {
  Vue.use(VueAwesomeSwiper)
  Vue.use(VuePano)
  Vue.prototype.$panorama = mergeDeep(defaultOptions, options)
  Vue.prototype.$panorama._clickEvent = Vue.prototype.$panorama.utils.isMobile ? 'touchstart' : 'click'

  const root = window.document.querySelector(':root')
  Object.entries(Vue.prototype.$panorama.styles.vars).forEach(([property, value]) => {
    root.style.setProperty('--panorama-' + property, value)
  })

  Components.forEach(component => {
    Vue.component(component.name, component)
  })

  if (!options || !options._store) {
    throw new Error('Please initialise plugin with a Vuex store.')
  }

  options._store.registerModule('Panorama', PanoramaStoreModule)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  PanoramaBuildSpot,
  PanoramaControl,
  PanoramaImageSource,
  PanoramaModal,
  PanoramaSpot,
  PanoramaSpotIcon,
  PanoramaUIAccordion,
  PanoramaUiPoint,
  PanoramaUiSelect,
  PanoramaAccordionIcon,
  PanoramaCallHintIcon,
  PanoramaCloseIcon,
  PanoramaSliderPoint
}
